<div class="center-in-page">
	<div>
		<img src="./assets/img/sso-login.png" alt="SSO Login">
		<span>Launching...</span>
	</div>
</div>
